<template>
    <section
        class="tile bg-blue-light flex min-h-0 w-full max-w-full min-w-0 flex-col gap-4 lg:gap-6"
        :class="$attrs.class">
        <header class="flex flex-col gap-4">
            <h2 v-if="title" class="order-2 text-3xl lg:text-4xl">{{ title }}</h2>
            <h3 v-if="subtitle" class="font-body order-1">{{ subtitle }}</h3>
        </header>
        <Swiper
            class="w-full max-w-full"
            :slides-per-view="1.15"
            :space-between="16"
            :breakpoints="{
                1024: { slidesPerView: blogs?.length < 3 ? blogs.length : 3, spaceBetween: 24 },
            }">
            <SwiperSlide v-for="blog in blogs" :key="blog.url">
                <BlogCard v-bind="blog" />
            </SwiperSlide>
        </Swiper>
    </section>
</template>

<script setup lang="ts">
import type { RelatedBlogsComponentModel } from '@su4r-frontend/api';
import { Swiper, SwiperSlide } from 'swiper/vue';

defineProps<RelatedBlogsComponentModel>();
defineOptions({
    inheritAttrs: false,
});
</script>

<style lang="css">
@import 'swiper/css';
</style>
